export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9401.810c4b94.jpg";